import { createCnoLine, createCnoPatient } from "../../../services/api";
import { normalizePatients, toQuantity } from "./cnoRules";

// Ancienne sauvegarde navigateur des fiches CNO, retirée après migration (SEC-008).
export const LEGACY_STORAGE_KEY = "cno-patients";

export function readLegacyPatients() {
    try {
        return normalizePatients(JSON.parse(localStorage.getItem(LEGACY_STORAGE_KEY) || "[]"));
    } catch {
        return [];
    }
}

export function removeLegacyPatients() {
    try {
        localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {}
}

// Recrée en base, un par un et dans l'ordre, les patients puis leurs lignes.
export async function migrateLegacyPatients(legacyPatients) {
    const migrated = [];
    for (const legacyPatient of legacyPatients) {
        const createdPatient = await createCnoPatient({
            nom: legacyPatient.nom,
            prenom: legacyPatient.prenom,
            adresse: legacyPatient.adresse,
            telephone: legacyPatient.telephone,
        });
        const patient = { ...createdPatient.data, cnos: [] };
        for (const legacyLine of legacyPatient.cnos || []) {
            const createdLine = await createCnoLine(patient.id, {
                produit: legacyLine.produit,
                quantite: toQuantity(legacyLine.quantite),
            });
            patient.cnos.push(createdLine.data);
        }
        migrated.push(patient);
    }
    return normalizePatients(migrated);
}
